import React, { SVGProps } from 'react';

const RedWarningIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={15}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="RedWarningIcon">
    <circle cx={7.5} cy={7.5} r={7.5} fill="#D75750" />
    <path
      d="M7.5 3.889v4.444M7.5 11.944h.01"
      stroke="#fff"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RedWarningIcon;
